import React from 'react';
import {Table as BaseTable} from 'desktop/sports/nba/players-list/single-game';

class Table extends BaseTable {}

export {Table};
